import React from 'react';
import FaqCard from './FaqCard';

const FaqCards = () => {
    return (
             <div className="space-y-4 mb-20">
        <FaqCard
          question="What's the minimum CGPA required for most companies?"
          answer="Most companies prefer a CGPA of 7.0, while some look for 7.5. Only a few top-tier firms ask for 8.0+. Maintaining a 7.5+ keeps most doors open."
        />
        <FaqCard
          question="What is the best way to prepare for interviews?"
          answer="Focus on Data Structures and Algorithms (DSA) and core CS subjects like OS, DBMS, and Networking. Combine this with 2-3 solid projects and regular mock interview practice."
        />
        <FaqCard
          question="Which is more important: DSA or Development?"
          answer="DSA is the gatekeeper for coding rounds, while Development makes your resume stand out and gives you things to talk about in the interview. Balance both, favoring DSA during placement season."
        />
        <FaqCard
          question="Which platforms should I use for practicing DSA?"
          answer="LeetCode and GeeksforGeeks are the gold standards. For competitive programming logic, Codeforces or CodeChef are excellent additions."
        />
        <FaqCard
          question="Which language should I learn first for DSA?"
          answer="C++ or Java are the most popular choices due to their speed and extensive libraries. Choose one, master its syntax, and then stick with it for all your DSA practice."
        />
      </div>

        
    );     
}

export default FaqCards;